import { SoundByte, SoundType } from "../enum/sounds";
import MonoBehavior from "../lib/MonoBehavior";
import Listener from "../util/Listener";

export default class SoundManager extends MonoBehavior {
    static Singleton: SoundManager;

    Init(): void {
        if (SoundManager.Singleton == undefined) {
            SoundManager.Singleton = this;
        } else if (!SoundManager.Singleton.Equals(this)) {
            this.gameObject.RemoveScript(this.id);
        }
    }

    //@ts-ignore
    masterVolume = localStorage.getItem("fVolumeMaster") ? parseFloat(localStorage.getItem("fVolumeMaster")) : 1;
    //@ts-ignore
    musicVolume = localStorage.getItem("fVolumeMusic") ? parseFloat(localStorage.getItem("fVolumeMusic")) : 1;
    //@ts-ignore
    sfxVolume = localStorage.getItem("fVolumeSfx") ? parseFloat(localStorage.getItem("fVolumeSfx")) : 1;
    listener: Listener = new Listener();

    PlaySound(sound: SoundByte, type: SoundType = SoundType.SFX, volume=1) {
        let sfx =  document.createElement("audio");

        switch (type) {
            case SoundType.MUSIC:
                sfx.volume = this.masterVolume * this.musicVolume;
                break;
            case SoundType.SFX:
                sfx.volume = this.masterVolume * this.sfxVolume;
                break;
        
            default:
                break;
        }

        sfx.autoplay = true;
        sfx.volume = volume;
        sfx.src = sound;
    }
}